/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import * as components from "../components/index.js";

export type InternalServerErrorResponseData = {
  meta: components.Meta;
  error: components.BaseError;
};

export class InternalServerErrorResponse extends Error {
  meta: components.Meta;
  error: components.BaseError;

  /** The original data that was passed to this error instance. */
  data$: InternalServerErrorResponseData;

  constructor(err: InternalServerErrorResponseData) {
    const message = "message" in err && typeof err.message === "string"
      ? err.message
      : `API error occurred: ${JSON.stringify(err)}`;
    super(message);
    this.data$ = err;

    this.meta = err.meta;
    this.error = err.error;

    this.name = "InternalServerErrorResponse";
  }
}

/** @internal */
export const InternalServerErrorResponse$inboundSchema: z.ZodType<
  InternalServerErrorResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  meta: components.Meta$inboundSchema,
  error: components.BaseError$inboundSchema,
})
  .transform((v) => {
    return new InternalServerErrorResponse(v);
  });

/** @internal */
export type InternalServerErrorResponse$Outbound = {
  meta: components.Meta$Outbound;
  error: components.BaseError$Outbound;
};

/** @internal */
export const InternalServerErrorResponse$outboundSchema: z.ZodType<
  InternalServerErrorResponse$Outbound,
  z.ZodTypeDef,
  InternalServerErrorResponse
> = z.instanceof(InternalServerErrorResponse)
  .transform(v => v.data$)
  .pipe(z.object({
    meta: components.Meta$outboundSchema,
    error: components.BaseError$outboundSchema,
  }));

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace InternalServerErrorResponse$ {
  /** @deprecated use `InternalServerErrorResponse$inboundSchema` instead. */
  export const inboundSchema = InternalServerErrorResponse$inboundSchema;
  /** @deprecated use `InternalServerErrorResponse$outboundSchema` instead. */
  export const outboundSchema = InternalServerErrorResponse$outboundSchema;
  /** @deprecated use `InternalServerErrorResponse$Outbound` instead. */
  export type Outbound = InternalServerErrorResponse$Outbound;
}
